<template>
  <div class="sfdocs__navigator">
    <Slide
      right
      disableEsc
      noOverlay
      :isOpen="fileInfoOpen"
      :burgerIcon="false"
      @closeMenu="
        () => {
          this.fileInfoOpen = false;
          this.sidebarEditable = false;
        }
      "
    >
      <div
        v-if="fileInfo"
        class="file-info"
        @click="(e) => {
            e.preventDefault();
            e.stopPropagation();
          }
        "
      >
        <div class="file-info__row">
          <div class="file-info__label">Name</div>
          <!-- <div class="file-info__data">{{ fileInfo.name }}</div> -->
          <input
            class="file-info__data"
            type="text"
            :disabled="!sidebarEditable"
            :value="fileInfo.name"
            @change="(e) => (editedFile.name = e.target.value)"
          />
        </div>
        <div class="file-info__row">
          <div class="file-info__label">Size</div>
          <div class="file-info__data">
            {{ prettyBytes(Number(fileInfo.size)) }}
          </div>
        </div>
        <div class="file-info__row">
          <div class="file-info__label">Created At</div>
          <div class="file-info__data">
            {{ format(fileInfo.created, 'MM/DD/YYYY hh:mm:ss a') }}
          </div>
        </div>
        <div class="file-info__row">
          <div class="file-info__label">Modified At</div>
          <div class="file-info__data">
            {{ format(fileInfo.updated, 'MM/DD/YYYY hh:mm:ss a') }}
          </div>
        </div>
        <div class="action-buttons">
          <button
            v-if="!sidebarEditable"
            class="action-button__info"
            @click="toggleSidebarEdit()"
          >
            Edit
          </button>
          <button
            v-if="sidebarEditable"
            class="action-button__success"
            @click="updateFileSidebar($event, fileInfo)"
          >
            Save
          </button>
          <button
            class="action-button__cancel"
            @click="deleteFileSidebar($event, fileInfo)"
          >
            Delete
          </button>
        </div>
      </div>
    </Slide>
    
    <PageHeader @files-added="uploadFiles" />
    <table class="sfdocs__files">
      <thead>
        <tr>
          <th>Type</th>
          <th class="file-info__name">Name</th>
          <th>Size</th>
          <th class="table-column__show">Created at</th>
          <th class="table-column__show">Last modified at</th>
          <th>{{ files.length ? 'Actions' : 'File count'}}</th>
        </tr>
      </thead>
      <tbody>
        <NavigatorItem
          v-for="directory in directories"
          :key="directory.name"
          :name="directory.name"
          :parent="'/'"
          :path="`/${directory.name}`"
          :children="directory.children"
        />

        <!-- Files list -->
        <tr v-for="file in files" :key="file.id" @click="downloadFile(file)" class="file-info__table-row">
          <td><span :class="['file-icon', file.type.includes('image') ? 'image-icon' : 'document-icon']"></span></td>
          <td class="file-info__name">
            <span>
              {{ file.name }}
            </span>
          </td>
          <td>
            {{ prettyBytes(Number(file.size)) }}
          </td>
          <td class="table-column__show">{{ format(file.created, 'MM/DD/YYYY hh:mm:ss a') }}</td>
          <td class="table-column__show">{{ format(file.updated, 'MM/DD/YYYY hh:mm:ss a') }}</td>
          <td class="action-buttons__table">
            <!-- <button
              class="action-button__cancel"
              @click="deleteFile($event, file)"
            >
              Delete
            </button> -->
            <button
              class="action-button__table"
              @click="moveFile($event, file)"
            >
              Move
            </button>
            <button class="action-button__table" @click="showInfo($event, file)">
              Info
            </button>
            <button v-if="file.type.includes('image')" class="action-button__table" @click.stop="openModal(file)">
              View
            </button>

            <!-- <button @click="showDropdown">&#9776;</button>
            <ul class="dropdown hidden">
              <li><a href="#">Sub-1</a></li>
              <li><a href="#">Sub-2</a></li>
              <li><a href="#">Sub-3</a></li>
            </ul> -->
          </td>
        </tr>
      </tbody>
    </table>

    <Dropzone @file-added="fileAdded" :enabled="currentDirectory !== '/'">
    </Dropzone>

    <div class="sfdocs__files_pending_move">
      <h3
        v-if="currentDirectory !== '/' && filesPendingMove.length !== 0"
        class="uploading__header"
      >
        Files Pending Move
      </h3>
      <table v-if="currentDirectory !== '/' && filesPendingMove.length !== 0">
        <thead>
          <tr>
            <th>Type</th>
            <th>Name</th>
            <th class="table-column__show">Created at</th>
            <th class="table-column__show">Last modified at</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="file in filesPendingMove" :key="file.file.id">
            <td><span :class="['file-icon', file.file.type.includes('image') ? 'image-icon' : 'document-icon']"></span></td>
            <td>
              <span>
                {{ file.file.name }}
              </span>
            </td>
            <td class="table-column__show">{{ format(file.file.created, 'MM/DD/YYYY hh:mm:ss a') }}</td>
            <td class="table-column__show">{{ format(file.file.updated, 'MM/DD/YYYY hh:mm:ss a') }}</td>
            <td class="action-buttons">
              <button
                class="action-button__cancel"
                @click="cancelFileMove($event, file.file)"
              >
                Cancel Move
              </button>
              <button
                class="action-button__success"
                @click="moveFileHere($event, file.file)"
              >
                Move Here
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3 v-if="uploading.length > 0" class="uploading__header">Uploading</h3>
    <table class="uploading__files" v-if="uploading.length > 0">
      <thead>
        <tr>
          <th>Name</th>
          <th class="table-column__show">Folder</th>
          <th>Size</th>
          <th class="uploading__files__progress__header">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="file in uploading" :key="file.id" class="file-info__table-row">
          <td>
            <span>
              {{ file.name }}
            </span>
          </td>
          <td class="table-column__show">
            <span :title="file.path" class="uploading__files__path">
              {{ file.path }}
            </span>
          </td>
          <td>
            <span>{{ file.size }}</span>
          </td>
          <td>
            <progress
              v-if="file.progress !== null"
              class="uploading__files__progress"
              :class="{
                uploading__files__progress__complete:
                  file.progress.loaded / file.progress.total === 1
              }"
              max="1"
              :value="file.progress.loaded / file.progress.total"
            >
              {{ file.progress.loaded / file.progress.total }}
            </progress>
          </td>
        </tr>
      </tbody>
    </table>

    <ImageModal v-if="currentImage" :image="currentImage" :deleteFile="deleteFile" @closeModal="currentImage = null" />

    <!-- Footer -->
    <PageFooter />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import VueNotifications from 'vue-notifications';
import NavigatorItem from '@/components/NavigatorItem';
import Dropzone from '@/components/Dropzone';
import PageHeader from '@/components/PageHeader';
import PageFooter from '@/components/PageFooter';
import ImageModal from '@/components/ImageModal.vue';

import { v4 as uuid } from 'uuid';
import prettyBytes from 'pretty-bytes';
import { format } from 'date-fns';

import { S3 } from 'aws-sdk';

import { Slide } from 'vue-burger-menu';

export default {
  components: {
    NavigatorItem,
    Dropzone,
    PageHeader,
    PageFooter,
    Slide,
    ImageModal
  },
  name: 'folder-view',
  data() {
    return {
      path: '/',
      s3: null,
      updateSub: null,
      uploading: [],
      filesPendingMove: [],
      fileInfoOpen: false, // determines if the sidebar is open
      fileInfo: null, // this is the file shown in the sidebar
      sidebarEditable: false, // determines if the sidebar is editable
      editedFile: {}, // used to store edited file data from sidebar,
      currentImage: null
    };
  },
  computed: {
    ...mapState(['directoryStructure', 'currentDirectory', 'directoryFiles']),
    directories() {
      if (this.directoryStructure === null) {
        return [];
      }
      return this.directoryStructure;
    },
    prefix() {
      return `/${this.$route.params.orgSalesforceId}/${
        this.$route.params.recordType
      }/${this.$route.params.recordTypeSalesforceId}${this.currentDirectory}`;
    },
    files() {
      if (this.directoryFiles === null) {
        return [];
      }
      return this.directoryFiles.filter((f) => {
        // const lastSlash = f.prefix.lastIndexOf('/');
        // const pathPrefix = f.prefix.slice(0, lastSlash);

        return this.prefix === f.prefix;
      });
    },
    iotTopic() {
      // eslint-disable-next-line prettier/prettier
      return `${this.$route.params.recordType}/${this.$route.params.recordTypeSalesforceId}/file-change`;
    }
  },
  methods: {
    ...mapActions([
      'getDirectoryContents',
      'setDirectory',
      'getLoginState',
      'setupDirectoriesAndStructure'
    ]),
    ...mapMutations({
      setObjectType: 'SET_OBJECT_TYPE',
      setSlideoutFile: 'SET_SLIDEOUT_FILE',
      setSildeoutOpen: 'SET_SLIDEOUT_OPEN'
    }),
    back() {
      this.setCurrentDir({
        currentDirectory: this.lastDirectory || '/'
      });
    },
    addS3Tags(uploadedFile) {
      return new Promise((resolve, reject) => {
        // adds tags to the created S3 object
        this.s3.putObjectTagging(
          {
            Bucket: process.env.VUE_APP_CONFIG_BUCKET,
            Key: uploadedFile.id,
            Tagging: {
              TagSet: [
                {
                  Key: 'Name',
                  Value: uploadedFile.name
                },
                {
                  Key: 'Prefix',
                  Value: this.prefix
                },
                {
                  Key: 'Domain',
                  Value: this.$route.params.recordType
                },
                {
                  Key: 'ExternalId',
                  Value: this.$route.params.recordTypeSalesforceId
                }
              ]
            }
          },
          (err, data) => {
            if (err) reject(err);
            resolve(data);
          }
        );
      });
    },
    /**
     * Called when a file is dropped into the Dropzone component
     *
     * @param {DataTransfer} dataTransfer - Browser event containing dragged & dropped files
     */
    async fileAdded(dataTransfer) {
      this.uploadFiles(dataTransfer.files);
    },
    /**
     * Uploads files to S3, adds them to the API and then emits an MQTT event
     *
     * @param {Arraylike} files - Arraylike object containing a list of files
     */
    async uploadFiles(files) {
      const uploadedFiles = await Promise.all(
        Array.from(files).map(async (file) => {
          try {
            const newFile = {
              name: file.name,
              path: this.prefix,
              entity: this.$route.params.recordTypeSalesforceId,
              domain: this.$route.params.recordType,
              id: uuid(),
              progress: null,
              size: prettyBytes(file.size),
              realSize: file.size,
              type: file.type
            };
            this.uploading.push(newFile);
            await this.$Amplify.Storage.put(newFile.id, file, {
              serverSideEncryption: 'AES256',
              customPrefix: {
                private: '',
                protected: '',
                public: ''
              },
              contentDisposition: `attachment;filename="${newFile.name}"`,
              contentType: newFile.type,
              progressCallback(progress) {
                newFile.progress = progress;
              }
            });
            return newFile;
          } catch (e) {
            console.log(e);
            this.errorNotification({
              message:
                'Error uploading file. You may have lost internet connection. If this problem persists, plesae contact support.'
            });
            /*alert(
              'Error uploading file. You may have lost internet connection. If this problem persists, plesae contact support.'
            );*/
          }
        })
      );
      Promise.all(
        uploadedFiles.map(async (uploadedFile) => {
          try {
            // post to API
            await this.$Amplify.API.post(
              'API',
              `/files/${uploadedFile.entity}`,
              {
                body: {
                  id: uploadedFile.id,
                  external_id: uploadedFile.entity,
                  prefix: uploadedFile.path,
                  name: uploadedFile.name,
                  domain: uploadedFile.domain,
                  size: `${uploadedFile.realSize}`,
                  type: uploadedFile.type,
                  rev: '1'
                }
              }
            );

            // refresh directory contents
            await this.getDirectoryContents({
              entity: this.$route.params.recordTypeSalesforceId
            });

            // publish message to MQTT
            await this.publishMessage(this.iotTopic, {
              action: 'create',
              file: uploadedFile
            });

            // add tags to S3 object
            await this.addS3Tags(uploadedFile);
          } catch (e) {
            if (Object.prototype.hasOwnProperty.call(e, 'response')) {
              if (e.response.status === 401) {
                this.errorNotification({
                  message:
                    'You do not have permission to add files to this folder.'
                });
                /*alert(
                  'You do not have permission to add files to this folder.'
                );*/
                // delete file from S3 if permission is denied to add to API
                await this.$Amplify.API.del('API', `/files/${uploadedFile.id}`);
              }
            }
          } finally {
            // remove files from uploading files list
            const fileIndex = this.uploading.findIndex(
              (file) => file.id === uploadedFile.id
            );
            this.uploading = this.uploading
              .slice(0, fileIndex)
              .concat(this.uploading.slice(fileIndex + 1));
          }
        })
      );
    },
    async downloadFile(file) {
      try {
        // get signedUrl from API
        const data = await this.$Amplify.API.get(
          'API',
          `/files/${this.$route.params.recordTypeSalesforceId}/${file.id}`,
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          }
        );

        // create and click an anchor element to start the download
        const a = document.createElement('a');
        a.download = file.name;
        a.href = data.signedUrl;
        a.click();
      } catch (e) {
        console.log(e);
      }
    },
    async deleteFile(e, file) {
      try {
        e.preventDefault();
        e.stopPropagation();

        const shouldDelete = window.confirm(
          'Are you sure you want to delete this file?'
        );

        if (shouldDelete) {
          try {
            // delete file
            await this.$Amplify.API.del('API', `/files/${file.id}`);
            // refresh contents
            await this.getDirectoryContents({
              entity: this.$route.params.recordTypeSalesforceId
            });

            // publish message to MQTT
            await this.publishMessage(this.iotTopic, {
              action: 'delete',
              file
            });
          } catch (e) {
            if (Object.prototype.hasOwnProperty.call(e, 'response')) {
              if (e.response.status === 401) {
                this.errorNotification({
                  message:
                    'You do not have permission to delete files in this folder.'
                });
                /*alert(
                  'You do not have permission to delete files in this folder.'
                );*/
              }
            }
          }
        }
      } catch (e) {
        console.log('Error deleting file:', e);
      }
    },
    /**
     * Wrapper for deleteFile that closes the sidebar once complete
     */
    async deleteFileSidebar(e, file) {
      await this.deleteFile(e, file);
      this.fileInfoOpen = false;
    },
    /**
     * Updates file
     */
    async updateFile(e, file) {
      await this.$Amplify.API.put('API', `/files/${file.entity}/${file.id}`, {
        body: file
      });
    },
    /**
     * Wrapper for updateFile that updates sidebar once complete
     */
    async updateFileSidebar(e, file) {
      this.toggleSidebarEdit();
      const newFile = {
        ...file,
        ...this.editedFile
      };

      // send request to update file
      await this.updateFile(e, newFile);

      // reset temporary file storage
      this.editedFile = {};

      // fetch update
      await this.getDirectoryContents({
        entity: this.$route.params.recordTypeSalesforceId
      });

      // update sidebar file
      this.fileInfo = newFile;

      await this.publishMessage(this.iotTopic, {
        action: 'updated',
        file
      });
    },
    /**
     * Flag file for moving by adding it to localStorage
     *
     * @param {MouseEvent} e
     * @param {Object} file
     */
    moveFile(e, file) {
      e.preventDefault();
      e.stopPropagation();

      // check if the key exists, set to [] if not
      const filesString =
        window.localStorage.getItem('filesPendingMove') || '[]';

      try {
        // check if the list is valid JSON
        let filesRoot = JSON.parse(filesString);

        // only allow 1 item to be in the "move" list
        filesRoot = [];

        filesRoot.push({
          file: {
            ...file,
            entity: this.$route.params.recordTypeSalesforceId
          },
          set: new Date()
        });

        this.successNotification({
          message:
            'File queued to move. Navigate to any other folder to move the file to it.'
        });
        /*alert(
          'File queued to move. Navigate to any other folder to move the file to it.'
        );*/

        window.localStorage.setItem(
          'filesPendingMove',
          JSON.stringify(filesRoot)
        );
      } catch (e) {
        if (e instanceof SyntaxError) {
          window.localStorage.removeItem('filesPendingMove');
        } else {
          console.log(e);
        }
      }
    },
    /**
     * Get file from localStorage and make request to 'move' it to current directory
     *
     * @param {MouseEvent} e
     * @param {Object} file
     */
    async moveFileHere(e, file) {
      e.preventDefault();
      e.stopPropagation();

      // call API to update file path
      try {
        await this.$Amplify.API.put('API', `/files/${file.entity}/${file.id}`, {
          body: {
            ...file,
            prefix: this.prefix,
            external_id: this.$route.params.recordTypeSalesforceId
          }
        });

        // remove file from filesPendingMove
        this.cancelFileMove(e, file);
      } catch (e) {
        if (Object.prototype.hasOwnProperty.call(e, 'response')) {
          if (e.response.status === 400) {
            if (
              e.response.data.error === 'One or more required fields are missing.' ||
              e.response.data.error === 'File id mismatch.'
            ) {
              this.errorNotification({
                message: 'Error moving file. Please contact support.'
              });
              // alert('Error moving file. Please contact support.');
            } else if (
              e.response.data.error === 'File domain cannot be changed.'
            ) {
              this.errorNotification({
                message: 'You can only move files within the same RecordType.'
              });
              // alert('You can only move files within the same RecordType.');
            }
          } else if (e.response.status === 401) {
            this.errorNotification({
              message: 'You do not have permission to move files here.'
            });
            // alert('You do not have permission to move files here.');
          } else if (e.response.status === 404) {
            this.errorNotification({
              message:
                'File to be moved does not exist. Please contact support.'
            });
            // alert('File to be moved does not exist. Please contact support.');
          }
        }
      }

      // update local directory contents
      await this.getDirectoryContents({
        entity: this.$route.params.recordTypeSalesforceId
      });

      // send IoT message so other clients update their listings
      await this.publishMessage(this.iotTopic, {
        action: 'delete',
        file
      });

      // also send message to the topic that the file was originally from
      await this.publishMessage(
        // eslint-disable-next-line prettier/prettier
        `${file.domain}/${file.entity}/file-change`,
        {
          action: 'moved',
          file
        }
      );
    },
    /**
     * Remove clicked file from localStorage
     *
     * @param {MouseEvent} e
     * @param {Object} file
     */
    cancelFileMove(e, file) {
      e.preventDefault();
      e.stopPropagation();

      const filesString = window.localStorage.getItem('filesPendingMove');
      if (filesString === null) {
        this.filesPendingMove = [];
      }

      try {
        // check if the key has valid JSON
        const filesRoot = JSON.parse(filesString);

        // find file in localStorage that matches clicked file
        const fileIndex = filesRoot.findIndex((f) => f.file.id === file.id);

        if (fileIndex > -1) {
          // remove clicked file
          filesRoot.splice(fileIndex, 1);
          // update localStorage
          window.localStorage.setItem(
            'filesPendingMove',
            JSON.stringify(filesRoot)
          );
        }
      } catch (e) {
        if (e instanceof SyntaxError) {
          // reset localStorage on parse error
          window.localStorage.setItem('filesPendingMove', '[]');
        } else {
          console.log(e);
        }
      }

      window.localStorage.setItem('filesPendingMove', '[]');
      this.updateFilesPendingMove();
    },
    /**
     * Show file info in the Slideout menu
     */
    showInfo(e, file) {
      e.preventDefault();
      e.stopPropagation();

      this.fileInfoOpen = true;
      this.fileInfo = file;
    },
    openModal(image) {
      this.currentImage = image;
    },
    /**
     * Switches between static and editable fields in the file info sidebar
     */
    toggleSidebarEdit() {
      this.sidebarEditable = !this.sidebarEditable;
    },
    /**
     * Update virtual directory structure on route change or initial load
     *
     * @param {Object} route - VueRouter route, either from initial load (this.mounted) or router hook
     */
    async setup(route) {
      try {
        if (route.params.recordType) {
          // set initial directory structure
          await this.setupDirectoriesAndStructure({
            entity: this.$route.params.recordType
          });
          // set initial object type
          await this.setObjectType({
            objectType: this.$route.params.recordType
          });

          this.updateFilesPendingMove();
        }
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * Sync the localStorage key filesPendingMove with the Vue state
     */
    updateFilesPendingMove() {
      // check if the key exists, if not, return []
      const filesString = window.localStorage.getItem('filesPendingMove');
      if (filesString === null) {
        this.filesPendingMove = [];
      }

      try {
        // check if the key has valid JSON
        let filesRoot = JSON.parse(filesString);
        if (!(filesRoot instanceof Array)) {
          // if its not an Array, overwrite it
          filesRoot = [];
        }
        const now = Date.now();
        const recentFiles = filesRoot.filter((fileEntry) => {
          // 120000ms = 2 minutes
          return (
            now - new Date(fileEntry.set) < 120000 &&
            fileEntry.file.prefix !== this.prefix // only show files not from this prefix
          );
        });

        this.filesPendingMove = recentFiles;

        // remove any items that were "expired"
        window.localStorage.setItem(
          'filesPendingMove',
          JSON.stringify(
            filesRoot.filter((f) => now - new Date(f.set) < 120000)
          )
        );
      } catch (e) {
        if (e instanceof SyntaxError) {
          // reset filesPendingMove if there's an error parsing the JSON
          window.localStorage.removeItem('filesPendingMove');
          this.filesPendingMove = [];
        } else {
          console.log(e);
        }
      }

      return this.filesPendingMove;
    },
    /**
     * Setup subscription to MQTT IoT topic
     */
    setupSub() {
      // subscribe to topic recordType/recordTypeSFID/fileChange
      this.updateSub = this.$Amplify.PubSub.subscribe(this.iotTopic).subscribe({
        next: async (data) => {
          try {
            // fetch directory contents when an event is received
            if (data.value.clientId !== this.$Amplify.PubSub._pluggables[0].clientId) {
              // only update current directory if another user sent IoT message
              await this.getDirectoryContents({
                entity: this.$route.params.recordTypeSalesforceId
              });
            }
          } catch (e) {
            this.errorNotification();
            console.log(e);
          }
        },
        error: (error) => {
          // this doesn't catch the 'disconnect' error, see:
          // https://github.com/aws-amplify/amplify-js/issues/2692
          console.log(error);
        },
        close: () => console.log('Done')
      });
    },
    /**
     * Publish an IoT payload to a topic. Wrapper for Amplify function
     * Reloads page on error as that means the WebSocket was interrupted
     *
     * @param {string} topic
     * @param {Object} payload
     */
    async publishMessage(topic, payload) {
      try {
        await this.$Amplify.PubSub.publish(topic, {
          ...payload,
          clientId: this.$Amplify.PubSub._pluggables[0].clientId
        });
      } catch (e) {
        // WebSocket broken, reload page
        window.location.reload();
      }
    },
    format,
    prettyBytes
  },
  watch: {
    currentDirectory() {
      // keeps Vue component in sync with localStorage when the prefix changes
      this.updateFilesPendingMove();
    }
  },
  async mounted() {
    try {
      // set directory to '/' on initial mount
      await this.setDirectory({
        path: '/',
        entity: this.$route.params.recordTypeSalesforceId
      });

      await this.setup(this.$route);

      const credentials = await this.$Amplify.Auth.currentCredentials();

      // create S3 object to be used for uploading files directly to the bucket
      this.s3 = new S3({
        credentials: this.$Amplify.Auth.essentialCredentials(credentials)
      });

      this.setupSub();
    } catch (e) {
      console.log(e);
    }
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      // setup on route change
      await this.setup(to);
      if (
        this.updateSub !== null &&
        this.updateSub.constructor.name !== 'Subscription'
      ) {
        // setup subscription if its not setup already
        this.setupSub();
      }
      next();
    } catch (e) {
      next('/');
    }
  },
  notifications: {
    successNotification: {
      title: 'Success!',
      message: '',
      type: VueNotifications.types.success
    },
    errorNotification: {
      title: 'Error!',
      message:
        'Something went wrong. If this problem persists, plesae contact support.',
      type: VueNotifications.types.error,
      timeout: 0
    }
  }
};
</script>
